(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fluff-hero"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fluff-video-hero'))customElements.define('fluff-video-hero',class extends HTMLElement{
 connectedCallback(){
  const video=this.querySelector('video');if(!video)return;
  this.abort=new AbortController();const signal=this.abort.signal;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');let inView=true;
  const sync=()=>{if(document.hidden||!inView||reduce.matches||navigator.connection?.saveData){video.pause()}else{video.play().catch(()=>{})}};
  this.observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;sync()},{threshold:0.1});
  this.observer.observe(this);document.addEventListener('visibilitychange',sync,{signal});reduce.addEventListener('change',sync,{signal});sync();
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect()}
});
  } catch(e) { console.error(e); }
})();

})();
